import Modal from 'react-modal';

// 设置全局样式
Modal.setAppElement('#root');

const defaultStyles = {
  content: {
    width: '480px',
    top: '20%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: '-20px',
  },
};

const mobileStyles = {
  content: {
    width: '360px',
    top: '40%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: '-10px',
  },
};

// 弹框组件
function WarnModal({ isMobile, isOpen, onRequestClose, title, subtitle, confirm, customStyles=defaultStyles, children }) {
  if (isMobile) {
    customStyles = mobileStyles
  }
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
    >
      <div className="modal-block modal-header-color modal-block-danger">
        <section className="panel">
          <header className="panel-heading">
            <h2 className="panel-title">{title}</h2>
          </header>
          <div className="panel-body">
            <div className="modal-wrapper">
              <div className="modal-icon">
                <i className="fa fa-times-circle"></i>
              </div>
              <div className="modal-text">
                <h4>{subtitle}</h4>
                <p>{children}</p>
              </div>
            </div>
          </div>
          <footer className="panel-footer">
            <div className="row">
              <div className="col-md-12 text-right">
                <button className="btn btn-danger modal-dismiss" onClick={onRequestClose}>{confirm}</button>
              </div>
            </div>
          </footer>
        </section>
      </div>
    </Modal>
  );
}

export default WarnModal;